import { useRef } from "react";

import Footer from "@/base/Footer";
import { FilterPanel } from "@/search/Langston/FilterPanel";
import { SearchContentSettings } from "@/search/Langston/SearchContentSettings";
import { ContentTypeFilter } from "../ContentTypeFilter";
import { SearchResults } from "../SearchResults";
import {
  footerCss,
  mainContentsContainerCss,
  mainContentsFlexColumnCss,
  searchPageContainerCss,
} from "./SearchPage.styles";

export const SearchPage = () => {
  const filterPanelRef = useRef<HTMLDivElement>(null);

  return (
    <>
      <div css={searchPageContainerCss}>
        <FilterPanel ref={filterPanelRef} />

        <div css={mainContentsContainerCss}>
          <div css={mainContentsFlexColumnCss}>
            <ContentTypeFilter />
            <SearchResults />
          </div>

          <Footer customCss={footerCss} />
        </div>
      </div>
      <SearchContentSettings />
    </>
  );
};
